//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Merge = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Merge"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M3.5 3.25C3.08437 3.25 2.75 2.91563 2.75 2.5C2.75 2.08437 3.08437 1.75 3.5 1.75C3.91563 1.75 4.25 2.08437 4.25 2.5C4.25 2.91563 3.91563 3.25 3.5 3.25ZM4.5125 4.7875C5.3875 4.4 6 3.52188 6 2.5C6 1.11875 4.88125 0 3.5 0C2.11875 0 1 1.11875 1 2.5C1 3.525 1.61563 4.40625 2.5 4.79063V11.2094C1.61563 11.5938 1 12.475 1 13.5C1 14.8813 2.11875 16 3.5 16C4.88125 16 6 14.8813 6 13.5C6 12.475 5.38438 11.5938 4.5 11.2094V8.5C5.33438 9.12813 6.375 9.5 7.5 9.5H10.2094C10.5938 10.3844 11.475 11 12.5 11C13.8813 11 15 9.88125 15 8.5C15 7.11875 13.8813 6 12.5 6C11.475 6 10.5938 6.61563 10.2094 7.5H7.5C5.94062 7.5 4.65625 6.30938 4.5125 4.7875ZM3.5 14.25C3.08437 14.25 2.75 13.9156 2.75 13.5C2.75 13.0844 3.08437 12.75 3.5 12.75C3.91563 12.75 4.25 13.0844 4.25 13.5C4.25 13.9156 3.91563 14.25 3.5 14.25ZM13.25 8.5C13.25 8.91562 12.9156 9.25 12.5 9.25C12.0844 9.25 11.75 8.91562 11.75 8.5C11.75 8.08438 12.0844 7.75 12.5 7.75C12.9156 7.75 13.25 8.08438 13.25 8.5Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
